import moment from 'moment-timezone';
import type { AppSettingsDatum } from './types';
import Preview from '../../components/preview';

export const appSettingsData: AppSettingsDatum[] = [
  {
    sectionTitle: 'General',
    sectionComponents: Preview,
    selects: [
      {
        title: 'Date Format',
        multiSelect: false,
        defaultValue: ['/'],
        description: 'Set your default date format',
        options: [
          { value: 'ddmmyyyy', label: 'DD/MM/YYYY' },
          { value: 'mmddyyyy', label: 'MM/DD/YYYY' },
          { value: 'mmmddyyyy', label: 'Month DD, YYYY' },
        ],
      },
      {
        title: 'Time Format',
        multiSelect: false,
        defaultValue: ['/'],
        description: 'Set your default time format',
        options: [
          { value: 'hours12', label: '12 hour' },
          { value: 'hours24', label: '24 hour' },
        ],
      },
      {
        title: 'Time Zone',
        multiSelect: false,
        defaultValue: ['America/Chicago'],
        description:
          'Set the time zone for your local time displayed in upper right hand area on main pages',
        options: moment.tz.names().map((zone: string) => ({ value: zone, label: zone })),
      },
    ],
  },
];
